import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { InvitationsService } from '../../modules/vms/invitations/invitations.service';

@Component({
    selector: 'app-invitation',
    templateUrl: './invitation.component.html',
    styleUrls: ['./invitation.component.scss'],
    standalone: false
})
export class InvitationComponent implements OnInit {
  token: string | null = null;
  loading = true;
  error: string | null = null;

  // dummy data (replace later by API result)
  data: any = {
    companyShort: 'SKH',
    title: 'Visitor Invitation',
    subtitle: 'SKH Visitor Management System',
    welcome: 'Welcome',
    nameTitle: 'Dear Guest',
    inviteLine: 'You are invited to visit',
    date: '',
    desk: '',
    contact: '',
    remarks: '',
    pin: [],
    safetyTitle: 'Safety Guidelines',
    safetyNote: 'Please read before your visit',
    footer: 'Best regards, SKH VMS',
    qrCode: '',
    guidelinePdf: ''
  };

  pinCopied = false;

  constructor(
    private route: ActivatedRoute,
    private invitationsService: InvitationsService
  ) { }

  ngOnInit(): void {
    // capture token for later API call if present in query or path
    this.token = this.route.snapshot.paramMap.get('token') || this.route.snapshot.queryParamMap.get('token');

    if (this.token) {
      if (this.isUuid(this.token)) {
        this.loadInvitation(this.token);
      } else {
        this.resolveShortCode(this.token);
      }
    } else {
      this.loading = false;
      this.error = 'Invalid Invitation Link';
    }
  }

  isUuid(str: string): boolean {
    const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    return uuidRegex.test(str);
  }

  resolveShortCode(code: string): void {
    this.invitationsService.resolveShortUrl(code).subscribe({
      next: (res) => {
        if (res && res.original_url) {
          window.location.href = res.original_url;
        } else {
          this.loading = false;
          this.error = 'Invalid Short Link';
        }
      },
      error: (err) => {
        console.error(err);
        this.loading = false;
        this.error = 'Failed to resolve link.';
      }
    });
  }

  loadInvitation(id: string): void {
    this.invitationsService.getInvitationInfo(id).subscribe({
      next: (res) => {
        this.data.nameTitle = `Dear ${res.fullname}`;
        this.data.inviteLine = `You are invited to visit ${res.desk?.name || ''}`;
        this.data.date = res.invitation_date;
        this.data.desk = res.desk?.name || '';
        this.data.contact = res.profile?.fullname || '';
        this.data.remarks = res.remarks || '-';

        // Handle PIN
        if (res.invitation_pin) {
          const pinStr = res.invitation_pin.toString();
          this.data.pin = pinStr.split('');
        }

        this.data.qrCode = res.qrCode;
        this.data.guidelinePdf = res.guidelinePdf;

        this.loading = false;
      },
      error: (err) => {
        console.error(err);
        this.error = 'Failed to load invitation.';
        this.loading = false;
      }
    });
  }

  copyPin(): void {
    const pin = this.data.pin.join('');
    if (navigator.clipboard) {
      navigator.clipboard.writeText(pin).then(() => {
        this.pinCopied = true;
        setTimeout(() => {
          this.pinCopied = false;
        }, 5000);
      });
    } else {
      alert('Clipboard not available. PIN: ' + pin);
    }
  }

  downloadPdf(): void {
    if (this.data.guidelinePdf) {
      window.open(this.data.guidelinePdf, '_blank');
    }
  }
}
